module.exports = __webpack_public_path__ + "static/media/logowhitesqr512.6760d0d0.png";